import type { FC } from 'react';

import { getQueryObj, setQueryObj } from './helpers/helpers';
import { changeLanguage, useAppTranslation } from './i18n';

export const LanguageChecker: FC = ({ children }) => {
  const { i18n } = useAppTranslation();

  // lang in query
  const query = getQueryObj();
  if (query.lang) {
    if (i18n.language !== query.lang) {
      changeLanguage(query.lang);
    }
    delete query.lang;
    setQueryObj(query);
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
